/* eslint-disable react/no-unused-state */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
import React from 'react';
import fetch from 'isomorphic-fetch';
import EventImageVideoGallery from './EventImageVideoGallery';

import merchantConfig from '../../merchant/config/merchant-config'

const backendBaseUrl = merchantConfig.backendUrl;
const loadImagesInOriginalSize = merchantConfig.loadImagesInOriginalSize;
let originalImagesEndpoint = backendBaseUrl + (!!loadImagesInOriginalSize ? '/api/public/v1/files/scaled/ORIGINAL/' : '/api/public/v1/files/scaled/IMG600/');
const thumbnailImagesEndpoint = backendBaseUrl + '/api/public/v1/files/scaled/IMG600/';

class EventImageVideoGalleryWrapper extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			images: [],
			videos: [],
			showSlider: false,
		};

		this.state.videos = !props.videos ? [] : props.videos
			.map(item => ({
				original: `https://img.youtube.com/vi/${item.videoId}/maxresdefault.jpg`,
				thumbnail: `https://img.youtube.com/vi/${item.videoId}/maxresdefault.jpg`,
				embedUrl: `https://www.youtube.com/embed/${item.videoId}?=rel0&autoplay=1`,
				originalClass: 'youtube-video',
				thumbnailClass: 'youtube-video',
			}));

		const imageIds = this.props.images
			.map(o => o.fileMetaDataId);
		this.fetchImageMetaData(imageIds);
	}

	fetchImageMetaData(ids) {
		const fetchedImageData = [];
		const requests = [];
		const fetchedImageDataInOrder = []
		ids.forEach((id) => {
			requests.push({id: id, request:`${backendBaseUrl}/api/public/v1/files/metaData/${id}`});
		});

		Promise.all(requests.map(requestElement =>
			fetch(requestElement.request)
				.then(response => response.json())
				.then((responseJson) => {
					fetchedImageData[requestElement.id] = responseJson;
				})
				.catch((error) => {
					console.error(`Couldn't load imageMetaData: ${error}`);
				})))
			.then(() => {
				ids.forEach(id => {
					if (fetchedImageData[id]) fetchedImageDataInOrder.push(fetchedImageData[id])
				})
				this.transformImageMetaDataCollectionAndChangeState(fetchedImageDataInOrder);
				this.checkShowSlider();
			});
	}

	transformImageMetaDataCollectionAndChangeState(imageCollectionToTransform) {
		const transformedImageCollection = imageCollectionToTransform
			.map(item => ({
				original: `${originalImagesEndpoint}${item.id}`,
				thumbnail: `${thumbnailImagesEndpoint}${item.id}`,
				description: `Quelle: ${item.source}`,
				originalAlt: item.altText,
				originalTitle: item.caption,
				fileMetaDataId: item.id,
			}));
		this.changeImagesInState(transformedImageCollection);
	}

	changeImagesInState(newImageList) {
		this.setState({ images: newImageList });
	}

	checkShowSlider() {
		if (this.state.videos || this.state.images) {
			this.setState({ showSlider: true });
		}
	}

	render() {
		return (
			this.state.showSlider ?
				<EventImageVideoGallery
					images={this.state.images}
					videos={this.state.videos}
				/> : ''
		);
	}
}
export default EventImageVideoGalleryWrapper;
